import React from 'react'

const WomanSadNotebook = () => {
  return (
    <svg
      width={237}
      height={229}
      viewBox="0 0 237 229"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx={117.5} cy={214.5} rx={117.5} ry={14.5} fill="#F3F5F8" />
      <path d="M137.163 165.428H37.371V216h99.792v-50.572z" fill="#4D4D4D" />
      <path
        d="M186.337 141.714c.412 2.578 7.791 61.501 8.978 62.481 1.187.979 13.828 3.144 14.912 1.495.206-2.578.516-43.664 1.187-47.325"
        fill="#C01414"
      />
      <path
        d="M43.975 129.446c-5.108-2.526 5.521 47.272 33.54 47.272 28.018 0 75.128-42.633 82.764-42.633 16.821 0 56.707 33.045 59.855 33.045 2.373-2.372 7.172-6.599 7.172-8.248 0-1.65-38.183-64.44-66.769-64.44-11.042 0-105.055 40.674-116.562 35.004z"
        fill="#D62929"
      />
      <path
        d="M59.713 130.27c5.573-1.289 12.538-4.536 18.73-7.887-16.77 5.464-30.546 9.021-34.468 7.062-2.683-1.34-.98 12.012 5.367 24.848-1.187-2.526-2.787-20.981 10.37-24.023z"
        fill="#1F161E"
      />
      <path
        d="M72.045 42.994c4.438.103 27.399-.567 33.694 5.413 4.696 4.433 19.195 42.684 21.414 56.088-9.753 4.949-80.082 38.612-101.857 23.817-.464-11.496 1.755-57.222 15.996-81.194 5.212-3.454 26.522-4.227 30.753-4.124z"
        fill="#4D4D4D"
      />
      <path
        d="M81.023 32.065H67.608v14.383c0 3.609 13.415 3.557 13.415 0V32.065z"
        fill="#DADADA"
      />
      <path
        d="M67.608 40.725c0-1.598 4.437-5.619 7.172-5.464.052-1.753-6.295-4.33-6.295-4.33l-.929 2.474.052 7.32z"
        fill="#1F161E"
      />
      <path
        d="M95.058 32.065c.31-1.392.464-2.835.464-4.227 0-10.62-8.307-19.229-18.575-19.229-10.268 0-18.576 8.61-18.576 19.229 0 1.443.155 2.835.465 4.227h36.222z"
        fill="#1F161E"
      />
      <path
        d="M90.156 19.074c-2.27-.36-4.54-2.113-6.14-3.3-9.03 6.6-14.809 6.703-15.428 6.703-.62 0-3.148 3.66-4.334 4.072l-.104-.051c1.394 7.63 8.72 12.733 16.357 11.34 7.637-1.391 12.745-8.711 11.352-16.34a12.453 12.453 0 00-.67-2.372c-.31 0-.672 0-1.033-.052z"
        fill="#DADADA"
      />
      <path
        d="M66.885 10.929c3.021 0 5.47-2.447 5.47-5.465A5.467 5.467 0 0066.885 0a5.467 5.467 0 00-5.47 5.464 5.467 5.467 0 005.47 5.465z"
        fill="#1F161E"
      />
      <path
        d="M69.31 22.167a2.314 2.314 0 00-2.219 2.423c.052 1.186 1.033 2.113 2.22 2.217"
        stroke="#1F161E"
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M105.223 82.791l14.345-3.66c1.393 2.32 8.101 25.312 8.101 25.312l-22.136 9.331c.309-4.33 1.187-24.28-.31-30.983z"
        fill="#F8CDBA"
      />
      <path
        d="M54.966 79.183c0 1.753-1.445 8.3-2.322 11.444M105.223 82.791c-.361-2.732-2.373-18.094-5.83-26.188"
        stroke="#1F161E"
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M105.223 82.791l14.345-3.66c1.393 2.32 8.101 25.312 8.101 25.312l-22.136 9.331c.309-4.33 1.187-24.28-.31-30.983z"
        fill="#DADADA"
      />
      <path
        d="M220.547 165.892c.309.516 4.592 5.774 6.088 5.826 1.497.051 10.681-6.135 10.268-7.475-.412-1.34-6.14-.464-7.172-.928s-3.199-2.681-3.56-3.66M197.998 204.762c-.103.567-.671 7.32.361 8.403 1.032 1.082 11.971 2.99 12.59 1.752.619-1.237-4.128-4.588-4.489-5.619-.361-1.031-.464-4.124 0-5.103"
        fill="#1F161E"
      />
      <path
        d="M180.867 105.887h-48.606l11.558-30.622h48.606l-11.558 30.622z"
        fill="#B3B3B3"
      />
      <path d="M140.362 104.752H91.756v1.135h48.606v-1.135z" fill="#B3B3B3" />
      <path
        d="M52.644 90.627c-.929 3.506-5.47 18.456-3.612 21.033 1.858 2.578 48.09-3.247 60.474-7.114 3.147-1.031 5.469-3.712 6.914-4.072 3.715-.619 7.327 1.649 8.359 5.258-4.953 2.371-76.315 38.818-99.43 22.579-4.387-3.144 3.302-41.292 3.663-43.2 3.818.464 23.632 5.516 23.632 5.516z"
        fill="#DADADA"
      />
      <path
        d="M105.894 105.474c1.393-.31 2.631-.67 3.612-.98 3.147-1.031 5.469-3.711 6.914-4.072 3.715-.619 7.327 1.649 8.359 5.258"
        stroke="#1F161E"
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.707 24.595a.5.5 0 01.698.112c.055.076.123.161.207.266l.004.006c.083.103.177.222.27.348.183.25.38.56.49.916.112.368.13.786-.05 1.22-.177.422-.521.812-1.039 1.175a.5.5 0 01-.574-.819c.42-.294.609-.548.69-.741a.76.76 0 00.017-.541c-.06-.198-.182-.402-.341-.62a9.117 9.117 0 00-.244-.314l-.012-.015c-.077-.097-.158-.198-.228-.295a.5.5 0 01.112-.698zM79.027 31.346a.5.5 0 00.695.13c.165-.114.49-.278.856-.334.355-.055.71-.004 1.02.251a.5.5 0 10.636-.77c-.586-.486-1.255-.554-1.808-.47a3.21 3.21 0 00-1.27.498.5.5 0 00-.129.695z"
        fill="#1F161E"
      />
      <ellipse cx={76.5} cy={25} rx={0.5} ry={1} fill="#0D0D0D" />
      <ellipse cx={86.5} cy={25} rx={0.5} ry={1} fill="#0D0D0D" />
      <path
        d="M75 29c1.105 0 2-.448 2-1s-.895-1-2-1-2 .448-2 1 .895 1 2 1zM88 29c1.105 0 2-.448 2-1s-.895-1-2-1-2 .448-2 1 .895 1 2 1z"
        fill="#FA9E9F"
      />
    </svg>
  )
}

export default React.memo(WomanSadNotebook)
